import { FetchCallTypeFn, useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { AlertButtonProps, useAlert } from '@rahtab/ui';
import { NavigationProp, useNavigation } from '@react-navigation/core';
import { useAppDispatch } from 'rahtab-redux';
import { useEffect } from 'react';
import { RootStackType } from '../Router';
import { setListingsLoading } from 'rahtab-redux/slices/listingsSlice';

function useSubmitOrder({
  offerCode,
  requestAmount,
  unitPrice,
  measureCode,
}: SubmitOrderProps): [FetchCallTypeFn, { loading: boolean }] {
  const alert = useAlert();
  const dispatch = useAppDispatch();
  const { navigate } = useNavigation<NavigationProp<RootStackType>>();
  const [submitOrder, { data, loading }] = useFetchCallType<SubmitResult>('MakeRequest', {
    params: `OfferCode=${offerCode}&RequestAmount=${requestAmount}&PricePerUnit=${unitPrice.toString()}&MeasureCode=${measureCode}`,
    skip: true,
  });
  useEffect(() => {
    if (data && !loading) {
      const { error, message, result: success } = data;
      const buttons: AlertButtonProps[] = [
        {
          color: 'secondary',
          variant: 'outlined',
          text: 'بازگشت',
          onPress: () => {
            dispatch(setListingsLoading('refreshing'));
            navigate('Listings', {});
          },
        },
      ];
      if (!success) buttons.pop();
      alert({
        title: 'پیام سیستم',
        message: success ? message : error,
        severity: success ? 'success' : 'error',
        hideBackButton: success,
        buttons,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.result, loading]);
  return [submitOrder, { loading }];
}

export default useSubmitOrder;

interface SubmitOrderProps {
  offerCode: string;
  requestAmount: string;
  unitPrice: number;
  measureCode: string;
}
interface SubmitResult {
  result: boolean;
  error: string;
  message: string;
}
